import { checkboxAnatomy as parts } from '@chakra-ui/anatomy'
import { createMultiStyleConfigHelpers, defineStyle } from '@chakra-ui/react'
import { textStyles } from '../foundations/textStyles'

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(parts.keys)

const baseStyleControl = defineStyle(props => {
  const { colorScheme } = props

  return {
    borderColor: 'inherit',
    _disabled: {
      _hover: {
        borderColor: 'transparent',
      },
    },
    _indeterminate: {
      bg: `${colorScheme}.500`,
      borderColor: `${colorScheme}.500`,
      color: 'white',

      _hover: {
        bg: `${colorScheme}.600`,
        borderColor: `${colorScheme}.600`,
      },
    },
    _checked: {
      bg: `${colorScheme}.500`,
      borderColor: `${colorScheme}.500`,
      color: 'white',

      _hover: {
        bg: `${colorScheme}.600`,
        borderColor: `${colorScheme}.600`,
      },
    },
  }
})

const baseStyleLabel = defineStyle(props => {
  return {
    fontWeight: 'semibold',
    color: 'text-neutral-900',
  }
})

const size = {
  sm: defineStyle({
    ...textStyles['sm'],
  }),
  md: defineStyle({
    ...textStyles['md'],
  }),
  lg: defineStyle({
    ...textStyles['lg'],
  }),
}

const sizes = {
  sm: definePartsStyle({
    control: {
      boxSize: '4',
    },
    label: size.sm,
    icon: {
      ...textStyles['3xs'],
    },
  }),
  md: definePartsStyle({
    control: {
      boxSize: '6',
    },
    label: size.md,
    icon: {
      ...textStyles.xs,
    },
  }),
  lg: definePartsStyle({
    control: {
      boxSize: '8',
      marginRight: '1',
    },
    label: size.lg,
    icon: {
      ...textStyles.md,
    },
  }),
}

const baseStyle = definePartsStyle(props => ({
  control: baseStyleControl(props),
  label: baseStyleLabel(props),
}))

export const Checkbox = defineMultiStyleConfig({
  baseStyle,
  sizes,
  defaultProps: {
    colorScheme: 'brand',
  },
})
